import React from "react";
import { Api } from "../app-controller.js";
import Swal from "sweetalert2";
import CreateForm from "../components/product-movements/CreateForm";

class MoveProducts extends React.Component {
  initialState = {
    nivelUsuario: localStorage.nivel_actual,
    actividad: "",
    cat_actividad: Api.loadCatalogue("cat_actividad"),
    establecimiento: "",
    cat_establecimiento: [],
    cat_actividad_recibe: [],
    establecimiento_recibe: "",
    actividad_recibe_id: "",
    actividad_recibe_nombre: "",
    razon_social: "",
    guid: "",
    guidValidado: false,
  };

  constructor(props) {
    super(props);

    this.state = this.initialState;
  }

  componentDidMount() {
    // si el usuario no es nivel cliente redireccionamos a home
    if (this.state.nivelUsuario !== "1") {
      window.location.href = "/";
    }

    // fn para filtrar catálogo de actividades, para este apartado solo necesitamos importandor, alamacenador, distribuidor y farmacia veterinaria
    this.filterActivities();
  }

  /********* LLAMADAS A LA API ***********/

  getEstablecimientosRegentePorActividad = (actividad_id) => {
    Api.loading(true);
    Api.fetch(
      "app/getEstablecimientosRegentePorActividad?actividad_id=" + actividad_id
    )
      .then((data) => {
        if (data) {
          this.setState({ cat_establecimiento: data });
        }
      })
      .then((data) => Api.loading(false));
  };

  /********** FUNCIONES PARA CONTROLAR EVENTOS **********/

  handleActividadChange = (obj) => {
    document.getElementById("razon_social").removeAttribute("readonly");
    document.getElementById("actividad_recibe").removeAttribute("readonly");
    document.getElementById("guid").removeAttribute("readonly");
    document.getElementById("guidBtn").classList = "btn btn-light btn-block";
    document.querySelector("#guidBtn i").classList = "fa fa-th";

    // Asignamos el valor a actividad
    this.setState({
      actividad: obj,
      actividad_recibe_id: this.initialState.actividad_recibe_id,
      actividad_recibe_nombre: this.initialState.actividad_recibe_nombre,
      razon_social: this.initialState.razon_social,
      guid: this.initialState.guid,
      guidValidado: this.initialState.guidValidado,
      establecimiento: this.initialState.establecimiento,
    });

    if (obj) {
      this.getEstablecimientosRegentePorActividad(obj.id);
      this.filterCatActividadEstRecibe(obj.id);
    }

    // limpamos errores si es que los hay
    this.cleanErrorsValidation("actividad");
    this.cleanErrorsValidation("establecimiento");
  };

  handleActividadRecibeChange = (e) => {
    this.cleanErrorsValidation("actividad_recibe");
    this.setState({
      actividad_recibe_id: e.target.value,
      actividad_recibe_nombre:
        e.target.options[e.target.selectedIndex].dataset.descripcion,
    });
  };

  handleEstablecimientoChange = (obj) => {
    // Asignamos el valor a establecimiento
    this.setState({
      establecimiento: obj,
    });

    // limpamos errores si es que los hay
    this.cleanErrorsValidation("establecimiento");
  };

  filterCatActividadEstRecibe = (actividad_envia_id) => {
    Api.loading(true);
    Api.fetch(
      "app/filterCatActividadEstRecibe?actividad_id=" + actividad_envia_id
    )
      .then((data) => {
        if (data) {
          this.setState({ cat_actividad_recibe: data });
        }
      })
      .then((data) => Api.loading(false));
  };

  handleRazonSocialChange = (evt) => {
    if (evt.target.name === "razon_social") {
      // Asignamos el valor a establecimiento
      this.setState({
        razon_social: evt.target.value.toUpperCase(),
      });

      // limpamos errores si es que los hay
      this.cleanErrorsValidation("razon_social");
    }

    if (evt.target.name === "guid") {
      // Asignamos el valor a establecimiento
      this.setState({
        guid: evt.target.value.toUpperCase(),
      });

      // limpamos errores si es que los hay
      this.cleanErrorsValidation("guid");
    }
  };

  handleGuidEstablecimiento = (evt) => {
    evt.preventDefault();
    let razonSocial = this.state.razon_social,
      guid = this.state.guid,
      establecimiento = {
        razon_social: "",
        guid: "",
        actividad_id: "",
      },
      actividad = this.state.actividad,
      actividad_recibe = this.state.actividad_recibe_id;

    if (!razonSocial) {
      this.handleValidations("razon_social", true);
    }

    if (!guid) {
      this.handleValidations("guid", true);
    }

    if (!actividad) {
      this.handleValidations("actividad", true);
    }

    if (!actividad_recibe) {
      this.handleValidations("actividad_recibe", true);
    }

    if (guid && razonSocial && actividad_recibe) {
      establecimiento.razon_social = razonSocial;
      establecimiento.guid = guid;
      establecimiento.actividad_id = actividad_recibe;

      Api.loading(true);
      Api.fetch(
        "app/getValidGUIDEstablishmentProductMovements",
        establecimiento,
        "POST"
      ).then((data) => {
        Api.loading(false);
        if (Object.keys(data).length > 0) {
          Swal.fire({
            icon: "success",
            title: "¡Establecimiento encontrado!",
            text: "Se ha encontrado establecimiento.",
            timer: "3000",
            confirmButtonText: "Regresar",
          });

          this.setState({
            establecimiento_recibe: data,
            actividad_recibe_id: actividad_recibe,
            guidValidado: true,
          });
          document
            .getElementById("razon_social")
            .setAttribute("readonly", true);
          document.getElementById("guid").setAttribute("readonly", true);
          document
            .getElementById("actividad_recibe")
            .setAttribute("readonly", true);
          document.getElementById("guidBtn").classList =
            "btn btn-success btn-block";
          document.querySelector("#guidBtn i").classList = "fas fa-check";
        } else {
          Swal.fire({
            icon: "warning",
            title: "¡Establecimiento no encontrado!",
            text: "Debe ingresar razón social con actividad y licencia activa.",
            // timer: "3000",
            confirmButtonText: "Regresar",
          });
        }
      });
    }
  };

  handleSubmit = (evt) => {
    evt.preventDefault();

    let productMoveData = { ...this.state };

    delete productMoveData.cat_establecimiento;
    delete productMoveData.cat_actividad;
    delete productMoveData.cat_actividad_recibe;

    if (!this.state.guidValidado) {
      Swal.fire({
        icon: "warning",
        title: "¡Atención!",
        text: "Debe ingresar datos de establecimiento válidos para poder realizar la solicitud",
        confirmButtonColor: "#d81402",
        confirmButtonText: `Regresar`,
      });
    } else {
      Swal.fire({
        icon: "question",
        title: "¿Completar transacción?",
        text: "¡Asegúrese que los datos estén completados correctamente!",
        showDenyButton: true,
        denyButtonColor: "red",
        confirmButtonColor: "#4CD964",
        showCancelButton: false,
        confirmButtonText: `Continuar`,
        denyButtonText: `Regresar`,
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.submitForm(productMoveData);
        }
      });
    }
  };

  submitForm = (productMoveData) => {
    Api.loading(true);
    Api.fetch("app/createMoveProductsRequest", productMoveData, "POST").then(
      (data) => {
        if (data.errors) {
          this.handleValidations(data.errors);
          Api.loading(false);
          this.fireSwal(
            "¡Verifique que los datos esten correctamente completados!",
            "warning"
          );
          return false;
        } else {
          Api.loading(false);
          Swal.fire({
            icon: "success",
            title: "¡La solicitud ha sido generada exitosamente!",
            confirmButtonText: "Continuar",
            timer: 3000,
          }).then(() => {
            window.location.href = "/movimientos-productos/egresos";
          });
          this.resetStates();
        }
      }
    );
  };

  // fn para marcar los campos que duevelen error desde la api
  handleValidations = (errors, guidValidation = false) => {
    if (guidValidation) {
      let msg = "";
      switch (errors) {
        case "razon_social":
          msg =
            "Debe ingresar la razón social para poder realizar la verificación GUID.";
          break;
        case "guid":
          msg = "Debe ingresar GUID para poder realizar la verificación GUID.";
          break;
        case "actividad":
          msg =
            "Debe Seleccionar actividad para poder realizar la verificación GUID.";
          break;
        case "actividad_recibe":
          msg =
            "Debe Seleccionar actividad para poder realizar la verificación GUID.";
          break;

        default:
          break;
      }

      document.getElementById(errors + "-error").style.display = "block";
      document.getElementById(errors + "-error").innerText = msg;
      document.getElementById(errors).classList.add("is-invalid");
    } else {
      for (const i in errors) {
        document.getElementById(i + "-error").style.display = "block";
        document.getElementById(i + "-error").innerText = errors[i];
        document.getElementById(i).classList.add("is-invalid");
      }
    }
  };

  // fn para depslegar mensajes de alerta sencillos
  fireSwal(title, icon = "error") {
    Swal.fire({
      title: title,
      icon: icon,
      timer: 3000,
    });
    return false;
  }

  // fn para reiniciar todos los estados una vez el submit sea éxitoso
  resetStates = () => {
    this.setState({
      actividad: this.initialState.actividad,
    });
  };

  /*********** Funciones ***********/

  // fn para filtrar actividades (ids: 18, 1, 2, 16)
  filterActivities = () => {
    Api.loading(true);
    Api.fetch("app/filterActivitiesForProductMovement")
      .then((data) => {
        if (data) {
          this.setState({ cat_actividad: data });
        }
      })
      .then((data) => Api.loading(false));
  };

  // funcion para validar solo enteros positivos en un input
  checkPositiveIntegers = (str) => {
    let regex = /^[1-9]\d*$/,
      response = false;

    if (str === "" || regex.test(str)) {
      response = true;
    }

    return response;
  };

  // fn para limpar errores cuando cambie el estado del input que los tenga
  cleanErrorsValidation = (elemento) => {
    let divError = document.getElementById(elemento + "-error"),
      classInvalid = document.getElementById(elemento);

    if (divError && classInvalid) {
      divError.style.display = "none";
      divError.innerText = "";
      classInvalid.classList.remove("is-invalid");
    }
  };

  render() {
    return (
      <CreateForm
        state={this.state}
        handleActividadChange={this.handleActividadChange}
        handleEstablecimientoChange={this.handleEstablecimientoChange}
        handleRazonSocialChange={this.handleRazonSocialChange}
        handleGuidEstablecimiento={this.handleGuidEstablecimiento}
        handleActividadRecibeChange={this.handleActividadRecibeChange}
        handleSubmit={this.handleSubmit}
      />
    );
  }
}

export default MoveProducts;
